/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetSliderModel,
  IGetSliderRequest,
  IMappers,
  IGetSliderResponse,
  IGetSliderResponseError,
  TGetSliderResponse,
} from './types';

const defaultConfig: TGetSliderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v1/get-slider/',
  hostType: 'api',
} as TGetSliderModel;

function createGetSliderModel(parameters: IGetSliderRequest): TGetSliderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSliderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetSliderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetSlider<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetSliderOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetSliderResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetSliderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSliderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetSliderResponseError);
    }
  }

  return { response, statusCode } as TGetSliderResponse;
}

export { defaultConfig, createGetSliderModel, fetchGetSlider };
